// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__12fMt","search":"Settings_search__1XH-f","filter":"Settings_filter__2PNDS"};